module.exports = __webpack_public_path__ + "static/media/blog-posts.30311d56.jpg";